import { useEffect, useState } from "react";
import { pushEvent } from "../lib/tracking";

const KEY = "cookie_consent";
const PIXEL_ID = "2054947862038346";

const loadMetaPixel = () => {
  if (window.fbq) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
};

const applyConsent = (value) => {
  const v = value === "granted" ? "granted" : "denied";
  window.gtag?.("consent", "update", { ad_storage: v, ad_user_data: v, ad_personalization: v, analytics_storage: v });
  pushEvent("consent_update", { consent_status: v });
  if (v === "granted") loadMetaPixel();
};

export const CookieConsent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (saved === "granted") loadMetaPixel();
    else if (!saved) setOpen(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    applyConsent(value);
    setOpen(false);
  };

  if (!open) return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-sm z-50 bg-navy/95 backdrop-blur-md border border-white/10 p-5 shadow-lg">
      <p className="font-body text-white/70 text-xs leading-relaxed mb-4">
        Utilizamos cookies de análise e publicidade para melhorar sua experiência, somente com sua autorização.{" "}
        <a href="/privacidade" className="text-gold hover:underline" data-testid="cookie-privacy-link">Política de Privacidade</a>
      </p>
      <div className="flex gap-2">
        <button onClick={() => choose("denied")} data-testid="cookie-reject-btn" className="flex-1 border border-white/15 text-white/70 font-body text-[11px] tracking-[0.1em] uppercase py-2.5 hover:bg-white/5 transition-colors duration-300">
          Recusar
        </button>
        <button onClick={() => choose("granted")} data-testid="cookie-accept-btn" className="flex-1 bg-gold text-white font-body font-semibold text-[11px] tracking-[0.1em] uppercase py-2.5 hover:bg-gold/85 transition-colors duration-300">
          Aceitar
        </button>
      </div>
    </div>
  );
};
